import { createContext, useContext, useState } from 'react';

const ToolbarContext = createContext();

export function ToolbarProvider({ children }) {
  const [config, setConfig] = useState(null); // null means "don't show toolbar"

  return (
    <ToolbarContext.Provider value={{ config, setConfig }}>
      {children}
    </ToolbarContext.Provider>
  );
}

export const useToolbar = () => useContext(ToolbarContext);